import {useEffect, useRef, useState} from "react";
import VolumeMeter from "../../helper/VolumeMeter";
import type WsClient from "../../ws/WsClient";

// Module scope: a `let` in the hook resets every render and loses the timer (RISKS.md/P2.19).
let talkingTimeout: any | null = null

const useMicLevel = (volumeMeter: VolumeMeter, ws: WsClient | null) => {
  const [ talking, setTalking ] = useState(false)
  const [volume, setVolume] = useState<number>(0)

  const volumeRef = useRef(volume)
  volumeRef.current = volume

  useEffect(() => {
    const updateVolume = () => {
      const value = volumeMeter.getVolume()
      setVolume(value)
    }

    const intervalVolume = setInterval(updateVolume, 50)

    return () => {
      clearInterval(intervalVolume)

      if (talkingTimeout) {
        clearTimeout(talkingTimeout)
      }
    }
  }, []);

  useEffect(() => {
    if (volumeRef.current >= 1) {
      if (talkingTimeout) {
        clearTimeout(talkingTimeout)
      }

      setTalking(true)

      talkingTimeout = setTimeout(() => {
        setTalking(false)
      }, 1000)
    }
  }, [volume]);

  useEffect(() => {
    if (ws) {
      // ws.sendRoomAction(currentRoom as string, 'talking', talking)
    }
  }, [talking]);

  return { volume, setVolume }
}

export default useMicLevel
